/**
 * User: herbert
 * Date: 20.02.16
 * Time: 21:45
 */

import Reflux from 'reflux';

export default Reflux.createActions({
	/** switch view to head of the stele */
	viewHead: {},
	/** switch view to bottom of the stele */
	viewBottom: {}
});
